import {Map, Record} from 'immutable';
import Rank from 'records/Rank';
import moment from 'moment';

export default class CoachingEffectivenessReport extends Record({
  activityRank: undefined,
  previousActivityRank: undefined,
  scorecardRank: undefined,
  previousScorecardRank: undefined,
  meetingTimeReceived: Map(),
  reviewTimeReceived: Map(),
  totalTimeReceived: Map(),
}) {
  constructor(obj = {}) {
    super(fromRawData(obj));
  }
}

function maybeRank(optionalRank) {
  return optionalRank ? Rank(optionalRank) : null;
}

function userToDuration(map) {
  return Map(map).mapEntries(([k, v]) => [k, moment.duration(v)]);
}

function fromRawData({
  activityRank,
  previousActivityRank,
  scorecardRank,
  previousScorecardRank,
  meetingTimeReceived,
  reviewTimeReceived,
}) {
  const reviewReceived = reviewTimeReceived ? userToDuration(reviewTimeReceived) : Map();
  const meetingReceived = meetingTimeReceived ? userToDuration(meetingTimeReceived) : Map();
  return {
    activityRank: maybeRank(activityRank),
    previousActivityRank: maybeRank(previousActivityRank),
    scorecardRank: maybeRank(scorecardRank),
    previousScorecardRank: maybeRank(previousScorecardRank),
    meetingTimeReceived: meetingReceived,
    reviewTimeReceived: reviewReceived,
    // we need the union of all coach user ids so we can pull missing users. Might as well have the overall totals,
    // too.
    totalTimeReceived: reviewReceived.mergeWith((a, b) => a.clone().add(b), meetingReceived),
  };
}
